import cBillingForm from '#themes/default/default/components/billingForm/billingForm.js';
import cFormInput from '#themes/default/default/components/formInput/formInput.js';
import cFormLine from '#themes/default/default/components/formLine/formLine.js';
import cInput from '#themes/default/default/components/input/input.js';
import cInputGroup from '#themes/default/default/components/inputGroup/inputGroup.js';
import cSelect from '#themes/default/default/components/select/select.js';

import template from './billingFormBrazil.html';

export default {
	name: 'CBillingFormBrazil',
	components: {
		cBillingForm,
		cFormInput,
		cFormLine,
		cInput,
		cInputGroup,
		cSelect
	},
	props: {
		customer: {
			type: Object,
			default: () => null
		},
		form: {
			type: Object,
			default: () => null
		},
		isCompany: {
			type: Boolean,
			default: false
		},
		order: {
			type: Object,
			default: () => null
		},
		providerAccount: {
			type: Object,
			default: () => null
		},
		selectedPayment: {
			type: Object,
			default: () => {}
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	data() {
		return {
			inputGroupErrors: [],
			inputGroupNote: '',
			inputGroupWarning: ''
		};
	},
	mounted() {
		// Set national Id in Brazil - OMS flow
		if (this.form.initial?.nationalId) {
			this.setNationalId(this.form.initial?.nationalId);
		}
	},
	computed: {
		nationalId: {
			get() {
				return this.form.nationalId.value.formatted;
			},
			set(value) {
				this.setNationalId(value);
			}
		},
		selectedStateBrazil() {
			return this.customer.billing.state;
		}
	},
	methods: {
		setNationalId(nationalId) {
			// Remove any characters but digit
			const clearedNationalId = nationalId.replace(/[^0-9]+/g, '');
			// Determine nationalId type (CPF or CNPJ)
			const nationalIdType = clearedNationalId.length > 13 ? 'CNPJ' : 'CPF';
			this.$store.commit('SET_FORM', {
				...this.form,
				nationalId: {
					value: {
						formatted: nationalId,
						unformatted: clearedNationalId
					},
					type: nationalIdType
				}
			});
		},
		storeStateValue({ value: selectedState } = {}) {
			this.$store.commit('SET_CUSTOMER', {
				...this.customer,
				billing: {
					...this.customer.billing,
					state: selectedState
				}
			});
		},
		validateCity(event) {
			this.validateField(event, 'string', 'billingCity');
			this.inputGroupErrors = this.validateField(event, 'string', 'billingCity', {
				errors: this.inputGroupErrors,
				labelFor: 'billingCity',
				errorMessage: this.t('form_errorCity')
			});
		}
	},
	template
};
